export default function checkPathIncludes(path: string, strToCompare: string) {
	return path.includes(strToCompare);
}
